<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'WEEKS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'WEEKS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-primary" *appAccess="'weeks:add'" (click)="onAdd()">
        <mat-icon>add</mat-icon>
        {{ 'WEEKS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="table-scroll">
      <div class="empty-state" *ngIf="loading">{{ 'WEEKS.LOADING' | translate }}</div>

      <table class="data-table" *ngIf="!loading && items.length; else emptyWeeks">
        <thead>
          <tr>
            <th style="width: 60px;">#</th>
            <th>{{ 'WEEKS.WEEK' | translate }}</th>
            <th>{{ 'WEEKS.START_DATE' | translate }}</th>
            <th>{{ 'WEEKS.END_DATE' | translate }}</th>
            <th style="width: 100px;">{{ 'WEEKS.ACTIVE' | translate }}</th>
            <th style="width: 200px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items" class="clickable" [class.row-active]="item.active" (click)="openRow(item)">
            <td>{{ item.ordinal }}</td>
            <td>{{ item.name }}</td>
            <td>{{ formatDate(item.startDate) }}</td>
            <td>{{ formatDate(item.endDate) }}</td>
            <td>
              <span class="status-badge" [class.active]="item.active">
                {{ (item.active ? 'WEEKS.YES' : 'WEEKS.NO') | translate }}
              </span>
            </td>
            <td class="row-actions" (click)="$event.stopPropagation()">
              <ng-container *appAccess="'weeks:edit'">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  *ngIf="!item.active"
                  (click)="setActive(item, true)"
                >
                  {{ 'WEEKS.SET_ACTIVE' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  *ngIf="item.active"
                  (click)="setActive(item, false)"
                >
                  {{ 'WEEKS.DEACTIVATE' | translate }}
                </button>
                <button type="button" class="btn btn-secondary btn-sm" (click)="onEdit(item)">
                  {{ 'COMMON.EDIT' | translate }}
                </button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #emptyWeeks>
        <div class="empty-state" *ngIf="!loading">{{ 'WEEKS.EMPTY' | translate }}</div>
      </ng-template>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ mode === 'view' ? (form.get('name')?.value || ('WEEKS.WEEK' | translate)) : ((mode === 'edit' ? 'WEEKS.EDIT_TITLE' : 'WEEKS.ADD_TITLE') | translate) }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-field">
          <label for="weekName">{{ 'COMMON.NAME' | translate }}</label>
          <input
            id="weekName"
            type="text"
            formControlName="name"
            [placeholder]="'WEEKS.NAME_PLACEHOLDER' | translate"
          />
        </div>
        <div class="form-field">
          <label for="weekOrdinal">{{ 'WEEKS.ORDER' | translate }}</label>
          <input id="weekOrdinal" type="number" formControlName="ordinal" />
        </div>
        <div class="form-field">
          <label for="weekStartDate">{{ 'WEEKS.START_DATE' | translate }}</label>
          <input id="weekStartDate" type="date" formControlName="startDate" />
        </div>
        <div class="form-field">
          <label for="weekEndDate">{{ 'WEEKS.END_DATE' | translate }}</label>
          <input id="weekEndDate" type="date" formControlName="endDate" />
        </div>
        <label class="checkbox-field">
          <input type="checkbox" formControlName="active" />
          <span>{{ 'WEEKS.ACTIVE_HINT' | translate }}</span>
        </label>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">
        {{ (mode === 'view' ? 'COMMON.CLOSE' : 'COMMON.CANCEL') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *ngIf="mode !== 'view'" (click)="submit()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
